module.exports = __webpack_public_path__ + "img/watermark.597271d2.png";